import React from 'react'
import NextImage from 'next/image'
import { Box } from '@mui/material'
import { EmtTypography, EmtIcon } from 'emt-components-v2'
import { useTranslation } from 'next-i18next'
import VariantImages from '@/assets/BaseVariantImages'

export const VeterinaryGuerricComponent: React.FC = () => {
  const t = useTranslation('petsitter').t
  return (
    <Box
      sx={{
        backgroundColor: '#F9F9F9',
        borderRadius: '16px',
        padding: '18px',
        border: '1px solid #E8E8EA',
        position: 'relative',
      }}
    >
      <EmtTypography variant="body2" color="#77757F" fontWeight="700" sx={{ maxWidth: '80%' }}>
        {t('reservations.newRequests.infoBox.veterinary.title')}
      </EmtTypography>
      <Box sx={{ maxWidth: '50%' }}>
        <Box sx={{ margin: '6px 0' }}>
          <EmtTypography variant="body1" fontWeight="700" lineHeight="1.1">
            {t('reservations.newRequests.infoBox.veterinary.text1')}
          </EmtTypography>
          <EmtTypography variant="body1" color="red.main" fontWeight="800" fontSize="18px" lineHeight="1.1">
            {t('reservations.newRequests.infoBox.veterinary.text2')}
          </EmtTypography>
        </Box>
        <EmtTypography variant="caption" color="#77757F" fontWeight="600" lineHeight="1.2">
          {t('reservations.newRequests.infoBox.veterinary.description')}
        </EmtTypography>
      </Box>
      <NextImage
        src={VariantImages.VetCedric}
        alt="Veterinary"
        width={160}
        style={{ position: 'absolute', bottom: 0, right: 0, borderRadius: '0 0 16px 0' }}
      />
    </Box>
  )
}

const VeterinaryComponent: React.FC = () => {
  const t = useTranslation('petsitter').t
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        backgroundColor: '#fff',
        borderRadius: '18px',
        padding: '20px 15px',
      }}
    >
      <EmtTypography variant="body1" fontWeight="700" fontSize="18px">
        {t('reservations.newRequests.infoBox.title')}
      </EmtTypography>
      <EmtTypography variant="body2" color="#4A4754">
        {t('reservations.newRequests.infoBox.description')}
      </EmtTypography>
      <EmtTypography variant="body2" color="#4A4754" fontWeight="700">
        {t('reservations.newRequests.infoBox.text')}
      </EmtTypography>
      <VeterinaryGuerricComponent />

      <Box sx={{ display: 'flex', gap: '5px', flexGrow: 1 }}>
        <Box
          sx={{
            backgroundColor: '#E8F8F4',
            borderRadius: '100vmax',
            padding: '3px 3px',
            display: 'flex',
            alignItems: 'center',
            gap: '3px',
            flexGrow: 1,
          }}
        >
          <EmtIcon
            className="emt-tick-circle-1"
            sx={{
              fontSize: '12px',
              color: '#18BA92',
            }}
          />
          <EmtTypography variant="body2" color="#18BA92" fontWeight="600" fontSize="10px" lineHeight="1">
            {t('reservations.newRequests.infoBox.chip1')}
          </EmtTypography>
        </Box>
        <Box
          sx={{
            backgroundColor: '#E8F8F4',
            borderRadius: '100vmax',
            padding: '3px 3px',
            display: 'flex',
            alignItems: 'center',
            gap: '3px',
            flexGrow: 1,
          }}
        >
          <EmtIcon
            className="emt-tick-circle-1"
            sx={{
              fontSize: '12px',
              color: '#18BA92',
            }}
          />
          <EmtTypography variant="body2" color="#18BA92" fontWeight="600" fontSize="10px" lineHeight="1">
            {t('reservations.newRequests.infoBox.chip2')}
          </EmtTypography>
        </Box>
      </Box>
    </Box>
  )
}

export default VeterinaryComponent
